import React, {
  useCallback, useEffect, useState, useMemo,
} from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import useLocale from '@/hooks/useLocale';
import { billingAnalytics } from '@/analytics';
import VpsStoreModal from '@/pages/Products/VpsOciDetailPage/pages/ProductTemplatesPage/commons/VpsStoreModal';

import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const ModalRebuild = ({
  onClose,
}) => {
  const dispatch = useDispatch();

  const vpsOci = useSelector(state => state.vpsOci);
  const { vps, productName } = (vpsOci && vpsOci.data) || {};
  const [requestRebuild, setRequestRebuild] = useState(false);

  const rebuildLoading = useSelector(state => state.vpsOci?.rebuild?.loading);

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: localeVpsOci } = productDetailsLocale;
  const { modal: localeRebuildModal } = localeVpsOci?.store?.rebuild;
  const { alert: localeVpsOciStoreModalAlert } = localeVpsOci?.store?.modal;

  const { hostingAndServers: hostingAndServersAnalytics } = billingAnalytics;

  const { id: hostingId } = useParams();

  const handleCloseModal = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleRebuild = useCallback(() => {
    if (hostingId) {
      setRequestRebuild(true);
      dispatch(vpsOciActions.rebuild.request(hostingId));
    }
  }, [dispatch, hostingId]);

  useEffect(() => {
    if (requestRebuild && !rebuildLoading) {
      handleCloseModal();
      setRequestRebuild(false);

      hostingAndServersAnalytics.hostingRebuildModalConfirmClick(productName);
    }
  }, [rebuildLoading, handleCloseModal, requestRebuild, productName, hostingAndServersAnalytics]);

  const modalConfig = useMemo(() => ({
    confirmRebuild: {
      title: localeRebuildModal.confirmRebuild.title,
      message: localeRebuildModal.confirmRebuild.message,
      alert: localeVpsOciStoreModalAlert.backup,
      testId: 'vpsoci-rebuild-confirm-modal',
      confirmButton: {
        text: localeRebuildModal.confirmRebuild.confirmButton,
        loading: rebuildLoading,
        action: handleRebuild,
        testId: 'vpsoci-rebuild-confirm-modal-confirm-button',
      },
      agreedTerms: localeRebuildModal.confirmRebuild.agreedTerms,
      closeButton: {
        text: localeRebuildModal.confirmRebuild.closeButton,
        action: handleCloseModal,
        testId: 'vpsoci-rebuild-confirm-modal-close-button',
      },
    },
  }), [handleCloseModal, handleRebuild, localeRebuildModal, localeVpsOciStoreModalAlert, rebuildLoading]);

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <VpsStoreModal
      modalType="confirmRebuild"
      modalConfig={modalConfig}
      onClose={handleCloseModal}
    />
  );
};

export default ModalRebuild;
